export default __webpack_public_path__ + "static/media/ForSale400.db88f0c2.jpg";